export default __webpack_public_path__ + "static/media/White Menu Icon.svg";